<input [value]="value" [type]="type" [checked]="checked" (change)="onChange()" />
<span class="label">{{ label }}<ng-content></ng-content></span>
